export interface FaqGetParams {
  query?: string;
  limit: number;
  offset: number;
}

export interface FaqQuestion {
  id: number;
  question: string;
  answer: string;
  order: number;
  active: boolean;
}

export interface FaqList {
  list: FaqQuestion[];
  count: number;
}

export class FaqQuestionUi {
  expanded = false;
  data: FaqQuestion;

  constructor(public faqQuestion: FaqQuestion) {
    this.data = faqQuestion;
  }
}
